import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {setTitle as ssrSetTitle} from 'external/dev_april_corgi+/js/server/ssr_aware';

export function Header({title}: {title: string | undefined}) {
  setTitle(title);

  return (
    <header className="flex items-center mb-12">
      <div
        className="bg-contain h-8 w-8"
        style="background-image: url(/static/bird-transparent.webp)"
      ></div>
      <div className="font-[Avenir] font-thin text-lg">Petri</div>
    </header>
  );
}

export function setTitle(title: string | undefined): void {
  if (title) {
    ssrSetTitle(`${title} - Petri`);
  } else {
    ssrSetTitle('Petri');
  }
}
